import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Folder18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 1.25C0.819167 1.25 0.25 1.81917 0.25 2.5V14.5C0.25 15.1808 0.819166 15.75 1.5 15.75H16.5C17.1808 15.75 17.75 15.1808 17.75 14.5V5.5C17.75 4.81917 17.1808 4.25 16.5 4.25H9.31066L6.53033 1.46967C6.38968 1.32902 6.19891 1.25 6 1.25H1.5ZM1.75 4.25V2.75H5.68934L7.18934 4.25L1.75 4.25ZM1.75 5.75V14.25H16.25V5.75H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

Folder18.displayName = 'Folder18';
export default Folder18;
